import angular from 'angular';
import 'angular-ui-router';
import 'angular-ui-router-title';
import 'satellizer';
import Login from './login/login';
import Logout from './logout/logout';
import Password from './password/password';
import AccountSettings from './settings/settings';

export default angular.module('app.components.account', [
  'ui.router',
  'satellizer',
  Login.name,
  Logout.name,
  Password.name,
  AccountSettings.name
])
  .config(($stateProvider, $urlRouterProvider) => {
    $stateProvider
      .state('accountSettings', {
        url: '/accountSettings',
        template: '<account-settings></account-settings>',
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.accountSettings');
          }
        },
        data: {
          permissions: {
            except: ['anonymous'],
            redirectTo: 'login'
          }
        }
      });
  })



/** WEBPACK FOOTER **
 ** ./src/components/account/account.js
 **/